import React from "react";
import { useSolrContext } from "@e-fork/solr";
import useTranslate from "@default/hooks/use-translate";
import Status from "@default/general-components/status/status";

const NoResults = () => {
  const { metaData, loading, error } = useSolrContext();
  const _t = useTranslate();

  if (metaData.totalRows !== 0 || loading || error) return null;

  return (
    <Status
      type="error"
      title={_t("overview.status.no_results.title")}
      message={_t("overview.status.no_results.message")}
      direction="vertical"
    />
  );
};

export default NoResults;
